export default function ReviewsSection() {
  return (
    <section id="reviews" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 text-sm font-medium px-4 py-2 rounded-full mb-4">
            <i className="ri-star-fill"></i>
            <span>고객 후기</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            실제 고객님들의 후기
          </h2>
          <p className="text-gray-500 text-lg mb-8">
            네이버 블로그에서 생생한 후기를 확인해보세요
          </p>

          <a
            href="https://m.blog.naver.com/PostList.naver?blogId=cholxida&tab=1"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-article-line text-xl"></i>
            <span>네이버 블로그 후기 보러가기</span>
            <i className="ri-external-link-line"></i>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {[
            { icon: "ri-shield-check-line", label: "신뢰할 수 있는 서비스", color: "bg-amber-100 text-amber-600" },
            { icon: "ri-lock-line", label: "개인정보 철저 보호", color: "bg-green-100 text-green-600" },
            { icon: "ri-heart-line", label: "유가족 배려 진행", color: "bg-rose-100 text-rose-600" },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-3 bg-stone-50 rounded-2xl p-6 border border-gray-100">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-gray-700 text-center">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
